import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IPLInsightData } from "./plInsights.types";

export const fetchPlInsightsAutomobileData = createAsyncThunk<
  IPLInsightData,
  { year?: string } | void,
  { rejectValue: string }
>(
  "plInsights/fetchPlInsightsAutomobileData",
  async (params, { rejectWithValue }) => {
    try {
      const year = params && "year" in params ? params.year : undefined;
      const res = await api.get("/policy/get-pl-insights-automobile-data", {
        params: year ? { year } : undefined,
      });
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "An error occurred while fetching PL Insights automobile data",
      );
    }
  },
);

export const fetchPlInsightsHabitationalData = createAsyncThunk<
  IPLInsightData,
  { year?: string } | void,
  { rejectValue: string }
>(
  "plInsights/fetchPlInsightsHabitationalData",
  async (params, { rejectWithValue }) => {
    try {
      const year = params && "year" in params ? params.year : undefined;
      const res = await api.get("/policy/get-pl-insights-habitational-data", {
        params: year ? { year } : undefined,
      });
      return res.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "An error occurred while fetching PL Insights habitational data",
      );
    }
  },
);
